<template>
  <div v-if="contentDetailState.content.item" class="bg-white pb-8">
    <HeroBar :bgSrc="getContentImageUrl(contentDetailState.content.item)">
      <div class="relative max-w-7xl mx-auto md:p-6">
        <div class="max-w-3xl mx-auto">
          <div v-if="contentDetailState.content.liveSession">
            <a @click.prevent="navigateToItem(contentDetailState.content.liveSession)" class="relative card-zoom cursor-pointer md:rounded-xl">
              <div class="card-zoom-image" :style="{ 'background-image' : 'url(' + getContentImageUrl(contentDetailState.content.item) + ')' }"></div>
              <div class="card-zoom-text flex">
                <h1 class="m-auto">
                  <button class="bg-red-500 hover:bg-red-600 py-2 px-3 rounded-md text-sm text-white font-bold">
                    <PlayIcon class="w-4 h-4 text-white m-auto inline" />
                    {{$filters.contentStatus(contentDetailState.content.liveSession.status)}}
                  </button>
                </h1>
              </div>
            </a>
          </div>
          <div v-else>
            <img :src="getContentImageUrl(contentDetailState.content.item)" alt="" class="md:rounded-xl ">
          </div>
        </div>
      </div>
    </HeroBar>
    <div class="text-center py-4 bg-blue">
      <button v-if="$filters.arrayItemsExist(subscriptionState.inPersonETickets)" @click.prevent="navigateToTicketOptions()" class="cursor-pointer inline-block bg-white rounded-lg px-4 py-2 text-lg font-bold text-blue text-center hover:bg-blue-dark hover:text-white justify-content-center">
        Register Now
      </button>
      <!-- <a v-if="contentDetailState.content.item.id === 134" href="https://docs.google.com/forms/d/e/1FAIpQLScy2yg9FZg6uoPL6JJd27MlrsSWm5gtACw84fWm-f7HtMkVDQ/viewform" class="cursor-pointer inline-block bg-white rounded-lg px-4 py-2 text-lg font-bold text-blue text-center hover:bg-blue-dark hover:text-white justify-content-center">
        Notify Me
      </a> -->
      <!-- <a v-if="contentDetailState.content.item.id === 135" href="https://docs.google.com/forms/d/e/1FAIpQLSfYI2GHOSsGk8KBiXozITDHMu3jqP3f6omg-aY2U7A7eK69Bg/viewform" class="cursor-pointer inline-block bg-white rounded-lg px-4 py-2 text-lg font-bold text-blue text-center hover:bg-blue-dark hover:text-white justify-content-center">
        Notify Me
      </a> -->
      <a v-if="contentDetailState.content.item.id === 136" href="https://docs.google.com/forms/d/e/1FAIpQLScy3MsRHUhjraZ_mAWoRmrmzzNOCQPhk5i91E_EDeBtQjY3cg/viewform" class="cursor-pointer inline-block bg-white rounded-lg px-4 py-2 text-lg font-bold text-blue text-center hover:bg-blue-dark hover:text-white justify-content-center">
        Notify Me
      </a>
    </div>

    <div id="details-top" class="mx-auto max-w-7xl mt-12 px-6">
      <div class="mx-auto lg:mx-0 lg:max-w-5xl">
        <h2 class="font-display text-4xl font-bold tracking-tighter text-blue sm:text-5xl">{{
          contentDetailState.content.item.title }}
        </h2>
        <div>
          <p class="mt-4 font-display text-xl tracking-tight text-gray-500 sm:text-2xl">
            {{ contentDetailState.content.item.description }}
          </p>
          <!-- <p class="mt-2 font-display text-lg tracking-tight text-gray-500">
            Only the evening sessions will be streamed online - so come and join us!
          </p> -->
        </div>
      </div>
      <div class="mt-4">
        <button v-if="contentDetailState.content.showFAQs || contentDetailState.content.item === 131" class="text-xl font-semibold tracking-tight text-blue-dark" @click="goToElementById('faqs-top')">
          View FAQs
        </button>
      </div>
      <dl class="mt-4 sm:grid sm:grid-flow-col gap-x-10 gap-y-6 lg:auto-cols-auto lg:grid-flow-col lg:grid-cols-none lg:justify-start lg:text-left">
        <div v-if="contentDetailState.content.earliestSessionDate">
          <dt class="mt-1 font-mono text-sm text-blue">When</dt>
          <dd class="mt-0.5 text-xl sm:text-2xl font-semibold tracking-tight text-blue-dark">
            <span>{{ contentDetailState.content.earliestSessionDate.toFormat('d.MM.yy') }}</span>
            <span
              v-if="contentDetailState.content.latestSessionDate.startOf('day') > contentDetailState.content.earliestSessionDate.startOf('day')">
              - {{ contentDetailState.content.latestSessionDate.toFormat('d.MM.yy') }}</span>
          </dd>
        </div>
        <div v-if="contentDetailState.content.item.address">
          <dt class="mt-1 font-mono text-sm text-blue">Venue</dt>
          <dd v-html="$filters.contentAddress(contentDetailState.content.item.address)" class="mt-0.5 text-xl sm:text-2xl  font-semibold tracking-tight text-blue-dark"></dd>
        </div>
        <!-- <div>
          <dt class="font-mono text-sm text-blue">&nbsp;</dt>
          <dd class="mt-0.5 text-xl sm:text-2xl  font-semibold tracking-tight text-blue-dark">FAQs</dd>
        </div> -->
      </dl>
    </div>

    <div class="max-w-7xl mx-auto mt-12 px-6">
      <!-- Notify section -->
      <div v-if="contentDetailState.content.item && contentDetailState.content.item.notify && contentDetailState.content.item.notifyUrl">
        <div class="mx-auto mt-10 max-w-7xl sm:px-6 lg:px-8">
          <div
            class="relative isolate overflow-hidden bg-blue-dark px-6 py-24 shadow-2xl sm:rounded-3xl sm:px-24 xl:py-32">
            <h2 class="mx-auto max-w-2xl text-center text-3xl font-bold tracking-tight text-white sm:text-4xl">Be
              notified when registration opens.</h2>
            <p class="mx-auto mt-2 max-w-xl text-center text-lg leading-8 text-gray-300">Registration is not yet open,
              but we can let you know when it is!</p>
            <div class="mx-auto mt-10 flex justify-center max-w-md gap-x-4">
              <a :href="contentDetailState.content.item.notifyUrl"
                class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-blue hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">Notify
                me</a>
            </div>
            <!-- <svg viewBox="0 0 1024 1024" class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2" aria-hidden="true">
            <circle cx="512" cy="512" r="512" fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fill-opacity="0.7" />
            <defs>
              <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(512 512) rotate(90) scale(512)">
                <stop stop-color="#7775D6" />
                <stop offset="1" stop-color="#E935C1" stop-opacity="0" />
              </radialGradient>
            </defs>
          </svg> -->
          </div>
        </div>
      </div>
      <div v-else>
        <GroupSchedule></GroupSchedule>
      </div>
    </div>

    <ContentFAQsKids v-if="contentDetailState.content.item && contentDetailState.content.item.id === 131"></ContentFAQsKids>
  </div>

  <!-- <div v-if="contentDetailState.content.item && contentDetailState.content.item.id === 132" class="bg-white">
    <NetherlandsConf></NetherlandsConf>
  </div> -->

  <!-- <div v-if="contentDetailState.content.item && contentDetailState.content.item.id === 136" class="bg-white">
    <NazSchool></NazSchool>
  </div> -->

  <div v-if="contentDetailState.content.item && contentDetailState.content.item.id === -138" class="bg-white">
    <div class="relative content-feature-img">
      <div class="absolute inset-0">
        <img class="w-full h-full object-cover" src="https://pslive.blob.core.windows.net/images/event/bfb-2026-banner.jpg" alt="" />
      </div>
    </div>
    <div class="relative z-50 flex-none border-b py-2">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-center lg:flex-nowrap">
        <div class="flex space-x-2 md:space-x-4">
          <a @click.prevent="scrollToId('info-panel')" class="inline-flex justify-center rounded-xl bg-transparent p-2 md:p-4 text-sm md:text-base font-semibold text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500" href="#">
            Info
          </a>
          <a @click.prevent="scrollToId('faqs-panel')" class="inline-flex justify-center rounded-xl bg-transparent p-2 md:p-4 text-sm md:text-base font-semibold text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500" href="#">
            FAQs
          </a>
          <!-- <a @click.prevent="scrollToId('support-panel')" class="inline-flex justify-center rounded-xl bg-transparent p-2 md:p-4 text-sm md:text-base font-semibold text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500" href="#">
            Support
          </a> -->
          <a @click.prevent="scrollToId('tickets')" class="inline-flex justify-center rounded-xl bg-transparent p-2 md:p-4 text-sm md:text-base font-semibold text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500" href="#">
            Tickets
          </a>
        </div>
      </div>
    </div>

    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" id="info-panel">
      <h1 class="mt-10 lg:mt-15 font-display text-5xl font-bold tracking-tighter text-gray-900 sm:text-6xl">
        Battle For Britain
      </h1>
      <p class="mt-2 text-2xl font-semibold text-gray-500 tracking-tight">
        Prayer Storm Conference 2026
      </p>
      <div class="mt-6 space-y-6 font-display text-2xl tracking-tight text-gray-600">
        <p>
          A spiritual war is raging over a generation. The harvest is ready. Heaven is searching for intercessors. Those who will rise, stand in the gap, and contend for this nation! This is more than a conference — it's a Battle For Britain. 🇬🇧<br/>
          Join us as we contend for the nations through prayer and intercession. With a Main Venue and Kids Venue for ages 7-16! Will you answer the call? &#x1F6E1;&#x1F525;
          <br/>
        </p>
      </div>
      <dl class="mt-10 grid md:grid-cols-2 gap-x-10 gap-y-4 md:auto-cols-auto md:grid-flow-col md:grid-cols-none md:justify-start text-left">
        <div>
          <dt class="font-mono text-sm text-gray-600">When</dt>
          <dd class="mt-0.5 text-2xl font-semibold tracking-tight text-gray-900">20-22 August 2026</dd>
        </div>
        <div>
          <dt class="font-mono text-sm text-gray-600">Venue</dt>
          <dd class="mt-0.5 text-2xl font-semibold tracking-tight text-gray-900">Manchester Central, Petersfield, M2 3GX, UK
          </dd>
        </div>
      </dl>
    </div>

    <div id="tickets">
      <div class="py-10 mt-10 text-center">
        <a class="rounded-xl bg-blue p-4 text-lg font-semibold text-white hover:bg-blue-dark focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500" href="/checkout/event/138/options" target="_blank">
          <span class="inline">Order Your Tickets Now</span>
        </a>
      </div>
    </div>

    <!-- <section id="speakers" aria-labelledby="speakers-title" class="py-10">
      <svg aria-hidden="true" width="0" height="0">
        <defs>
          <clipPath id=":R57qfja:-0" clipPathUnits="objectBoundingBox">
            <path
              d="M0,0 h0.729 v0.129 h0.121 l-0.016,0.032 C0.815,0.198,0.843,0.243,0.885,0.243 H1 v0.757 H0.271 v-0.086 l-0.121,0.057 v-0.214 c0,-0.032,-0.026,-0.057,-0.057,-0.057 H0 V0">
            </path>
          </clipPath>
          <clipPath id=":R57qfja:-1" clipPathUnits="objectBoundingBox">
            <path
              d="M1,1 H0.271 v-0.129 H0.15 l0.016,-0.032 C0.185,0.802,0.157,0.757,0.115,0.757 H0 V0 h0.729 v0.086 l0.121,-0.057 v0.214 c0,0.032,0.026,0.057,0.057,0.057 h0.093 v0.7">
            </path>
          </clipPath>
          <clipPath id=":R57qfja:-2" clipPathUnits="objectBoundingBox">
            <path
              d="M1,0 H0.271 v0.129 H0.15 l0.016,0.032 C0.185,0.198,0.157,0.243,0.115,0.243 H0 v0.757 h0.729 v-0.086 l0.121,0.057 v-0.214 c0,-0.032,0.026,-0.057,0.057,-0.057 h0.093 V0">
            </path>
          </clipPath>
        </defs>
      </svg>
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 id="speakers-title" class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
          Guests &amp; Speakers
        </h2>
        <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
          We have an amazing lineup of worship leaders, speakers, and of course, the Prayer Storm team joining us this year. Click for bios!
        </p>
        <div class="mt-10 grid grid-cols-1 items-start gap-x-8 gap-y-8 sm:mt-16 sm:gap-y-16 lg:grid-cols-4">

          <div class="lg:col-span-4">
            <div class="grid grid-cols-1 gap-x-8 gap-y-10 ui-not-focus-visible:outline-none sm:grid-cols-2 sm:gap-y-16 md:grid-cols-3">
              <div v-for="speaker in speakers" :key="speaker.id">
                <div class="cursor-pointer" @click="showSpeakerModal(speaker)">
                  <div class="profile-img group relative transform overflow-hidden rounded-xl">
                    <div class="absolute inset-0">
                      <img alt="" :src="speaker.img" class="absolute inset-0 h-full w-full object-cover transition duration-300 group-hover:scale-110" :class="{ 'scale-105': isHovered }">
                    </div>
                  </div>
                  <h3 class="mt-4 font-display text-2xl font-bold tracking-tight text-slate-900">{{ speaker.name }}</h3>
                  <p class="text-lg tracking-tight text-gray-500 italic">{{ speaker.venue }} Venue {{ speaker.role }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <section v-if="campaign" id="support-panel" aria-labelledby="accomodation-title" class="py-10">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
          Support
        </h2>
        <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
          We cannot make this happen without you! Please consider donating to help us reach our fundraising goal and keep ticket prices low.
        </p>
        <div class="mt-6 flex">
          <div class="w-1/3 hidden md:block">
            <img src="https://pslive.blob.core.windows.net/images/event/bfb-2026-thumb.jpg" class="w-full rounded-md" />
          </div>
          <div class="w-full md:w-3/4 md:pl-6">
            <div class="flex justify-between pb-4">
              <a class="font-bold text-lg hover:underline" href="https://donate.stripe.com/3cIaEY899evN1Zzg3adQQ0c">
                {{ campaign.title }}
              </a>
              <div class="flex-none pt-2">
                <a class="bg-blue hover:bg-blue-dark rounded-md px-6 py-3 text-md font-semibold text-white" href="https://donate.stripe.com/3cIaEY899evN1Zzg3adQQ0c">
                  Donate Now
                </a>
              </div>
            </div>
            <div class="overflow-hidden rounded-full bg-gray-200 mt-4">
              <div class="h-2 rounded-full bg-blue" :style="{ width: progressPercent + '%' }" />
            </div>
            <div class="flex justify-between my-4">
              <div class="mr-6">
                <div class="text-lg font-bold">{{ raisedDisplay }}</div>
                <div>Raised</div>
              </div>
              <div>
                <div class="text-lg font-bold">{{ targetDisplay }}</div>
                <div class="text-right">Total Goal</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="schedule" aria-labelledby="schedule-title" class="py-10">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
          Schedule
        </h2>
        <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
          Three amazing days of worship, prayer and teaching.
          <br/>
          <em>**Early release schedule, subject to change.</em>
        </p>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 sm:gap-x-4 lg:gap-x-8">
          <section>
            <ol role="list" class="rounded-xl mt-10 space-y-8 bg-white/60 px-10 py-14 text-center shadow-xl backdrop-blur border">
              <li>
                <h3 class="text-xl font-semibold tracking-tight text-gray-900">
                  20th August 2026
                </h3>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 1</h4>
                <p class="mt-1 tracking-tight text-gray-900">Thursday Afternoon</p>
                <p class="mt-1 font-mono text-sm text-slate-500">14:00 - 16:00 BST</p>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 2</h4>
                <p class="mt-1 tracking-tight text-gray-900">Thursday Evening</p>
                <p class="mt-1 font-mono text-sm text-slate-500">18:00 - 22:00 BST</p>
              </li>
            </ol>
          </section>
          <section>
            <ol role="list" class="rounded-xl mt-10 space-y-8 bg-white/60 px-10 py-14 text-center shadow-xl backdrop-blur border">
              <li>
                <h3 class="text-xl font-semibold tracking-tight text-gray-900">
                  21st August 2026
                </h3>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 3</h4>
                <p class="mt-1 tracking-tight text-gray-900">Friday Morning</p>
                <p class="mt-1 font-mono text-sm text-slate-500">10:00 - 12:30 BST</p>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 4</h4>
                <p class="mt-1 tracking-tight text-gray-900">Friday Afternoon</p>
                <p class="mt-1 font-mono text-sm text-slate-500">14:00 - 16:00 BST</p>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 5</h4>
                <p class="mt-1 tracking-tight text-gray-900">Friday Evening</p>
                <p class="mt-1 font-mono text-sm text-slate-500">18:00 - 22:00 BST</p>
              </li>
            </ol>
          </section>
          <section>
            <ol role="list" class="rounded-xl mt-10 space-y-8 bg-white/60 px-10 py-14 text-center shadow-xl backdrop-blur border">
              <li>
                <h3 class="text-xl font-semibold tracking-tight text-gray-900">
                  22nd August 2026
                </h3>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 6</h4>
                <p class="mt-1 tracking-tight text-gray-900">Saturday Morning</p>
                <p class="mt-1 font-mono text-sm text-slate-500">10:00 - 12:30 BST</p>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 7</h4>
                <p class="mt-1 tracking-tight text-gray-900">Saturday Afternoon</p>
                <p class="mt-1 font-mono text-sm text-slate-500">14:00 - 16:00 BST</p>
              </li>
              <li>
                <h4 class="text-lg font-semibold tracking-tight text-gray-900">Session 8</h4>
                <p class="mt-1 tracking-tight text-gray-900">Saturday Evening</p>
                <p class="mt-1 font-mono text-sm text-slate-500">18:00 - 22:00 BST</p>
              </li>
            </ol>
          </section>
        </div>
      </div>
    </section>

    <!-- <section id="volunteer-panel" aria-labelledby="accomodation-title" class="py-10">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
          Volunteer
        </h2>
        <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
          We are looking for a passionate group of volunteers to help us make this conference a success. If you would like to volunteer for this conference then please complete our online application form.
        </p>
        <div class="mt-6 flex">
          <div class="w-full">
            <a href="/volunteer">
              <img src="https://pslive.blob.core.windows.net/images/promotion/46355310-6362-11f0-b7f0-4976ac6ac5bf-promotion.jpg" class="w-full rounded-md" />
            </a>
            <p class="mt-4 font-display text-2xl tracking-tight text-gray-600 italic font-bold text-center">Volunteers attend the conference for free! <span class="font-normal">With a minimum four sessions serving.</span></p>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="accomodation" aria-labelledby="accomodation-title" class="py-10">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
          Accommodation in Manchester
        </h2>
        <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
          Marketing Manchester Convention Bureau is the official accommodation provider for Prayer Storm 2025
          Annual Conference.
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          <strong>All rooms are held on an on-line system, allowing you to book and secure your own
          accommodation using either pro-forma invoices or credit/debit card. If you require any assistance
          with your reservation, support is available via the Accommodation Booking Team.</strong>
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          To book accommodation for this event, please use the following link:<br/>
          <a class="text-blue font-bold hover:underline" href="https://book.passkey.com/e/50924225">https://book.passkey.com/e/50924225</a>
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          Negotiated delegate rates will be available to book until the end of the day on <strong>Thursday 24th July
          2025</strong>, so please book as soon as possible to guarantee a room. If you have any queries about the
          website, please contact Marketing Manchester Convention Bureau (<a class="text-blue font-bold hover:underline" href="mailto:abs@visitmanchester.com">abs@visitmanchester.com</a>).
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          <strong>About Manchester</strong>
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          For more information on Manchester as a destination please log onto
          <a class="text-blue font-bold hover:underline" href="https://www.meetinmanchester.com/">
            https://www.meetinmanchester.com/
          </a>;
          here you will discover all things to do in Manchester - from
          events and attractions to fine dining and a great night out.
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          Download a digital version of the
          <a class="text-blue font-bold hover:underline" href="https://manchestergrowthcouk.sharepoint.com/sites/MMC/Shared%20Documents/Conference%20Team/3.%20ABS/2.%20ABS%20docs%20-%20NON%20EVENT/ABS%20Account%20Management%20&%20Client%20Services%20Support%20Templates/CSA%20Templates/Templates/TEMPLATE%20-%20ABS%20Proposal%20Landscape%20-%20v2.doc">city center map</a>
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          For city transport information please see
          <a class="text-blue font-bold hover:underline" href="http://www.tfgm.com/">http://www.tfgm.com/</a>
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          <strong>Contacts</strong>
        </p>
        <p class="mt-2 font-display text-lg text-gray-600">
          Should you have any queries, please contact Manchester Convention Bureau at
          <a class="text-blue font-bold hover:underline" href="mailto:abs@visitmanchester.com">abs@visitmanchester.com</a>.
        </p>
      </div>
    </section> -->

    <section id="how-to-get-here" class="py-12 bg-white">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
          Getting to Manchester Central
        </h2>
        <div class="mt-4">
          <ul class="space-y-4 text-lg">
            <li>
              <span class="font-bold">By Bus:</span>
              <span>
                See The Bee Network
                <a href="https://www.tfgm.com/the-bee-network" target="_blank" class="text-blue-600 underline">
                  www.tfgm.com/the-bee-network
                </a>
              </span>
            </li>
            <li>
              <span class="font-bold">By Tram:</span>
              <span>
                St. Peter's Square Stop is the closest
              </span>
            </li>
            <li>
              <span class="font-bold">By Train:</span>
              <span>
                Manchester Oxford Road Station
                <span class="text-gray-500">(5 min walk)</span>
              </span>
            </li>
            <li>
              <span class="font-bold">By Plane:</span>
              <span>
                Manchester Airport
              </span>
            </li>
            <li>
              <span class="font-bold">By Taxi/Uber:</span>
              <span>
                Drops off and pick up zones directly in front of venue
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <div id="">
      <div class="py-10 text-center">
        <a class="rounded-xl bg-blue p-4 text-lg font-semibold text-white hover:bg-blue-dark focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500" href="/checkout/event/138/options" target="_blank">
          <span class="inline">Order Your Tickets Now</span>
        </a>
      </div>
    </div>

    <ContentFAQsConf></ContentFAQsConf>
  </div>
  <SpeakerModal />
</template>

<script>
import { computed, defineComponent, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useContent } from '@/composables/useContent'
import { useEvents } from '@/composables/useEvents'
import { useCampaigns } from '@/composables/useCampaigns'
import GroupSchedule from '@/components/GroupSchedule.vue'
import SpeakerModal from '@/components/events/speakers/SpeakerModal.vue'
import ContentFAQsConf from '@/components/ContentFAQsConf.vue'
import ContentFAQsKids from '@/components/ContentFAQsKids.vue'
// import NazSchool from '@/components/content-info/NazSchool.vue'
// import FurnaceConf from '@/components/content-info/FurnaceConf.vue'
// import NetherlandsConf from '@/components/content-info/NetherlandsConf.vue'
import HeroBar from '@/components/HeroBar.vue'
import store from '../store'
import { PlayIcon } from '@heroicons/vue/20/solid'
import { useMemberships } from '@/composables/useMemberships'
import { useETickets } from '@/composables/useETickets'
import { DateTime } from 'luxon'

const CAMPAIGN_ID = 'mx4n8g0a75c5l6l'

export default defineComponent({
  name: 'ContentGroup',
  components: {
    GroupSchedule,
    ContentFAQsKids,
    ContentFAQsConf,
    HeroBar,
    PlayIcon,
    // NazSchool,
    // NetherlandsConf,
    // FurnaceConf,
    SpeakerModal
  },

  setup () {
    const { speakerModalState } = useEvents()
    const x = Math.floor(Math.random() * 3) + 2
    const imgSrc = '/img/banners/ps-banner-' + x + '.jpg'

    const router = useRouter()
    const route = useRoute()
    const contentGuid = ref(route.params.guid)
    if (!route.params.type) {
      if (route.path.indexOf('conference') >= 0) {
        route.params.type = 'conference'
      }
      if (route.path.indexOf('school') >= 0) {
        route.params.type = 'school'
      }
      if (route.path.indexOf('event') >= 0) {
        route.params.type = 'event'
      }
    }

    const contentType = ref(route.params.type)
    const { subscriptionState, contentDetailState, searchContentDetail, getContentImageUrl, goContent } = useContent()
    const { getCampaignById } = useCampaigns()
    const campaignState = getCampaignById(CAMPAIGN_ID)
    const campaign = computed(() => campaignState.result)
    const { searchMemberships } = useMemberships()
    const { searchETickets } = useETickets()

    const toMajorCurrency = (price) => {
      const value = Number(price)
      if (!Number.isFinite(value)) {
        return 0
      }

      return value / 100
    }

    const getCurrencyCode = (currencyCode) => {
      const normalized = String(currencyCode || '').toUpperCase()
      if (normalized === 'GBP' || normalized === 'GPB') {
        return 'GBP'
      }

      return normalized || 'GBP'
    }

    const formatMoney = (amount, currencyCode) => {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: getCurrencyCode(currencyCode),
        maximumFractionDigits: 0
      }).format(amount)
    }

    const raisedAmount = computed(() => {
      return toMajorCurrency(campaign.value?.expand?.raised?.price)
    })

    const targetAmount = computed(() => {
      return toMajorCurrency(campaign.value?.expand?.target?.price)
    })

    const raisedDisplay = computed(() => {
      return formatMoney(raisedAmount.value, campaign.value?.expand?.raised?.currency)
    })

    const targetDisplay = computed(() => {
      return formatMoney(targetAmount.value, campaign.value?.expand?.target?.currency)
    })

    const progressPercent = computed(() => {
      if (!targetAmount.value) {
        return 0
      }

      const ratio = (raisedAmount.value / targetAmount.value) * 100
      return Math.max(0, Math.min(100, Math.round(ratio)))
    })

    const showSpeakerModal = (speaker) => {
      speakerModalState.speaker = speaker
      speakerModalState.show = true
    }

    onMounted(() => {
      loadScreen(true)
    })

    onUnmounted(() => {
      clearScreenPolling()
    })

    const clearScreenPolling = () => {
      if (window.screenPolling) {
        clearInterval(window.screenPolling)
      }
    }
    const startScreenPolling = () => {
      // check if there are link items - no point polling if not!
      if (contentDetailState.content.sessionItems && contentDetailState.content.sessionItems.length > 0) {
        // check if all are on demand - no point polling if so!
        let allOD = true
        contentDetailState.content.sessionItems.forEach(linkItem => {
          if (linkItem.status !== 4) {
            allOD = false
          }
        })
        // start polling if so!
        if (!allOD) {
          window.screenPolling = setInterval(() => {
            loadScreen(false)
          }, 60000) // every minute
        }
      }
    }

    const navigateToTicketOptions = () => {
      if (contentDetailState.content.item) {
        router.push('/checkout/event/' + contentDetailState.content.item.id + '/options')
      }
    }

    const loadScreen = (initialLoad) => {
      const searchReq = {
        type: contentType.value,
        guid: contentGuid.value,
        expectUser: store.getters.isLoggedIn
      }
      searchContentDetail(searchReq, initialLoad)
        .then((result) => {
          if (initialLoad) {
            clearScreenPolling()
            startScreenPolling()
          }
        }).catch(() => {
          if (initialLoad) {
            alert('Failed to load the screen, please refresh and try again.')
          }
        })
    }

    const goToSchedule = () => {
      const scrollTo = document.getElementById('schedule-top')
      scrollTo.scrollIntoView({ behavior: 'smooth' })
    }

    const navigateToItem = (item) => {
      goContent(item, router, route)
    }

    const goToElementById = (elementId) => {
      const scrollTo = document.getElementById(elementId)
      scrollTo.scrollIntoView({ behavior: 'smooth' })
    }

    const buildSubscriptions = async () => {
      let eTicketData
      let memberships
      const subscriptions = []
      const eTickets = []
      const inPersonETickets = []

      if (contentDetailState.content.onlineMemberships && contentDetailState.content.onlineMemberships.length > 0) {
        if (!memberships) {
          memberships = await searchMemberships()
        }
        if (memberships && memberships.length > 0) {
          memberships.forEach(membership => {
            if (contentDetailState.content.onlineMemberships.indexOf(membership.id) >= 0) {
              membership.isEnabled = false
              if (contentDetailState.content.activeMemberships.indexOf(membership.id) >= 0) {
                membership.isEnabled = true
              }
              subscriptions.push(membership)
            }
          })
        }
      }

      if (contentDetailState.content.onlineETickets && contentDetailState.content.onlineETickets.length > 0) {
        if (!eTicketData) {
          eTicketData = await searchETickets()
        }
        if (eTicketData && eTicketData.length > 0) {
          eTicketData.forEach(eTicket => {
            if (contentDetailState.content.onlineETickets.indexOf(eTicket.id) >= 0) {
              eTicket.earlyBirdDateTime = DateTime.fromISO(eTicket.earlyBirdEndsAt)
              const now = DateTime.now()
              if (eTicket.earlyBirdDateTime > now) {
                eTicket.isEarlyBird = true
              } else {
                eTicket.isEarlyBird = false
              }
              eTicket.isEnabled = false
              if (contentDetailState.content.activeETickets.indexOf(eTicket.id) >= 0) {
                eTicket.isEnabled = true
              }
              eTickets.push(eTicket)
            }
          })
        }
      }

      if (contentDetailState.content.inPersonETickets && contentDetailState.content.inPersonETickets.length > 0) {
        if (!eTicketData) {
          eTicketData = await searchETickets()
        }
        if (eTicketData && eTicketData.length > 0) {
          eTicketData.forEach(eTicket => {
            if (contentDetailState.content.inPersonETickets.indexOf(eTicket.id) >= 0) {
              eTicket.earlyBirdDateTime = DateTime.fromISO(eTicket.earlyBirdEndsAt)
              const now = DateTime.now()
              if (eTicket.earlyBirdDateTime > now) {
                eTicket.isEarlyBird = true
              } else {
                eTicket.isEarlyBird = false
              }
              eTicket.isEnabled = false
              if (contentDetailState.content.activeETickets.indexOf(eTicket.id) >= 0) {
                eTicket.isEnabled = true
              }
              inPersonETickets.push(eTicket)
            }
          })
        }
      }

      subscriptionState.subscriptions = subscriptions
      subscriptionState.eTickets = eTickets
      subscriptionState.inPersonETickets = inPersonETickets
    }

    watch(
      () => contentDetailState.content.onlineMemberships,
      () => {
        buildSubscriptions()
      }
    )
    watch(
      () => contentDetailState.content.onlineETickets,
      () => {
        buildSubscriptions()
      }
    )

    const scrollToId = (elementId) => {
      setTimeout(() => {
        const scrollTo = document.getElementById(elementId)
        scrollTo.scrollIntoView({ behavior: 'smooth' })
      }, 200)
    }

    const speakers = [
      { id: 4, name: 'Lou Engle', venue: 'Main', role: 'Speaker', img: '/img/profile/PROFILE_LOU.jpg', bio: 'Lou Engle, a veteran revivalist and intercessor, is internationally known for his leadership in the prayer and fasting movements that have sparked global revival. As the co-founder of The Call, Lou Engle has mobilised millions in prayer for national and global transformation. His ministry is marked by a deep prophetic calling, emphasizing consecration, intercession, and revival. Through his ministry, Lou Engle continues to challenge believers to live with wholehearted devotion, compelling them to intercede for an outpouring of God\'s Spirit and to contend for a revival that will sweep the nations.' },
      { id: 5, name: 'Karen Wheaton', venue: 'Main', role: 'Speaker', img: '/img/profile/PROFILE_KAREN.jpg', bio: 'Karen Wheaton, founder of The Ramp in Hamilton, Alabama (USA), leads a global movement marked by awakening, encounter, and passionate pursuit of God\'s presence. Her ministry has transformed the lives of countless young people across the world through powerful, Spirit-led teaching and abandoned worship. Karen Wheaton\'s heart burns to see the glory of God revealed on earth, rooted deeply in the unshakable foundation of the Word and the Spirit—pillars that define and drive her message. With a voice forged through both personal triumphs and trials, she calls this generation to spiritual awakening and deeper intimacy with God, carrying a mandate for lasting transformation in the Body of Christ.' },
      { id: 10, name: 'Isi Igenegba', venue: 'Main', role: 'Speaker', img: '/img/profile/PROFILE_ISI.jpg', bio: 'Isi Igenegba is a prophetic voice and teacher with a deep passion to see the Body of Christ fully awakened to truth, identity, and intimacy with God. As a leader she carries a strong anointing to unlock purpose and stir revival through the Word and the Spirit. Her ministry is marked by depth, clarity, and a compelling call to spiritual maturity and transformation. With a heart rooted in intercession and revelation, Isi Igenegba equips believers to walk in boldness, purity, and authority. Her voice challenges complacency and ignites a hunger for deeper encounters with Jesus. Through teaching, mentorship, and prophetic insight, Isi Igenegba is raising a generation grounded in Scripture, led by the Spirit, and driven by a mandate to reveal God\'s kingdom on earth.' },
      { id: 1, name: 'James Aladiran', venue: 'Main', role: 'Speaker', img: '/img/profile/PROFILE_JAMES.jpg', bio: 'James Aladiran, founder and director of Prayer Storm, is a passionate leader dedicated to awakening a generation to prayer. Raised in a family of missionaries, James Aladiran\'s ministry began after a life-changing encounter with God during his university years. Since then, he has dedicated his life to calling believers into a deeper prayer life, challenging the Church to become a house of prayer for all nations. As the author of Life on Fire, James Aladiran encourages believers to cultivate fervent prayer and active, Spirit-led intercession, believing that through prayer, revival can break forth across the UK and beyond.' },
      { id: 3, name: 'Matt Varah Wilson', venue: 'Main', role: 'Speaker', img: '/img/profile/PROFILE_MATT.jpg', bio: 'Matt Varah Wilson is a passionate leader at Prayer Storm, where he plays a key role in igniting fervent intercession for national and global revival. With a heart on fire for prayer and holiness, Matt Varah Wilson is deeply committed to fostering intimacy with God and inspiring believers to walk in complete devotion to Christ. His leadership is characterised by a prophetic vision that calls for the transformation of lives through the power of prayer. Matt Varah Wilson’s ministry focuses on cultivating a generation of prayer warriors who will contend for revival and usher in God\'s kingdom through persitent, heartfelt intercession.' },
      { id: 9, name: 'Matt Gilman', venue: 'Main', role: 'Worship Leader', img: '/img/profile/PROFILE_MATTG.jpg', bio: 'Matt Gilman is a worship leader and singer-songwriter whose music and ministry focus on fostering deep, Spirit-led worship. Matt Gilman is recognised for his passion for leading others into profound encounters with Jesus. As a key member of the Influence Music collective, Matt Gilman\'s worship projects have inspired believers worldwide. His commitment to leading worship that invites intimacy with God continues to touch lives, sparking a movement of passionate prayer and devotion among a new generation of worshipers.' },
      { id: 6, name: 'David Forlu', venue: 'Main', role: 'Worship Leader', img: '/img/profile/PROFILE_DAVID.jpg', bio: 'David Forlu is a catalytic voice to this generation, known for awakening hearts to the presence of God. As a worship leader he carries a deep burden to see lives transformed through encounter with the Holy Spirit. His ministry is marked by prophetic clarity, fervent worship, and a relentless pursuit of global revival. Rooted in intimacy with Jesus, David calls believers to radical obedience, deep consecration, and a lifestyle shaped by prayer. With a voice forged in surrender and spiritual hunger, he leads a movement ignited by intercession, awakening, and the fire of God\'s presence—mobilising a generation to fulfill their divine purpose.' },
      { id: 11, name: 'TY Bello', venue: 'Main', role: 'Worship Leader', img: '/img/profile/PROFILE_TY.jpg', bio: 'TY Bello is a prophetic singer, songwriter and worship leader whose songs have ignited hearts around the world. Known for her deep sensitivity to the Holy Spirit, TY Bello carries a sound that ushers people into powerful encounters with God\'s presence. Based in Nigeria, her ministry goes beyond music — blending intercession, creativity, and worship to release heave\'s atmosphere wherever she goes. Through her worship and heart for revival, she\'s been a voice of awakening in this generation.' },
      { id: 2, name: 'Rebecca Aladiran', venue: 'Main', role: 'Worship Leader', img: '/img/profile/PROFILE_REBECCA.jpg', bio: 'Rebecca Aladiran is a passionate intercessor, worship leader, and co-leader of Prayer Storm, where she is deeply involved in mobilising prayer, fasting, and revival. Known for her prophetic insight and teaching, Rebecca Aladiran has ministered at several global conferences, inspiring believers to pursue a lifestyle of consecration and prayer. Her heart for revival is evident in her leadership, and she is committed to raising up a generation that will walk in deeper intimacy with God through powerful intercession and worship.' },
      { id: 7, name: 'Josh Green', venue: 'Kids', role: 'Speaker', img: '/img/profile/PROFILE_JOSH.jpg', bio: 'Josh Green is the co-founder of Gen Zeal, a movement focused on igniting revival within Generation Z. With a background in evangelism, Josh Green has preached to thousands globally, instilling a passion for prayer, holiness, and spiritual awakening among youth. Previously the Youth Director for 24-7 Prayer in Great Britain, Josh Green\'s heart is to see young people encounter the transformative power of Jesus. Josh Green\'s ministry is defined by a relentless pursuit of revival, inspiring the next generation to live fully devoted lives in Christ and to stand firm in their faith amidst a changing world.' },
      { id: 8, name: 'Stacie Reecer', venue: 'Kids', role: 'Speaker', img: '/img/profile/PROFILE_STACIE.jpg', bio: 'Stacie Reeser is the Lead Pastor of Ramp Church Manchester and Co-Director of The Ramp UK, a ministry devoted to igniting spiritual revival across Europe. Originally from the US, Stacie Reeser and her husband Joe Reeser have made it their mission to cultivate a culture of prayer, worship, and community transformation in the UK. Stacie Reeser\'s ministry emphasises the power of God\'s word to renew lives, inspiring individuals to pursue deeper intimacy with God. With a heart to equip believers for Kingdom work, Stacie Reeser is passionate about seeing hearts awakened to God\'s presence and seeing communities radically transformed by the gospel.' }
    ]

    return {
      speakers,
      showSpeakerModal,
      imgSrc,
      contentGuid,
      contentType,
      campaign,
      raisedDisplay,
      targetDisplay,
      progressPercent,
      subscriptionState,
      contentDetailState,
      getContentImageUrl,
      goToSchedule,
      goToElementById,
      navigateToItem,
      navigateToTicketOptions,
      scrollToId,
      speakerModalState
    }
  }
})
</script>

<style scoped>
.card-zoom {
  @apply relative flex items-center justify-center overflow-hidden shadow-xl w-full;
  padding-bottom: 56.25%; /* 16:9 */
}
.card-zoom-image {
  @apply absolute inset-0 transition-all duration-500 ease-in-out transform bg-center bg-cover;
}
.card-zoom-text {
  @apply absolute inset-0 text-3xl font-black transition-all duration-500 ease-in-out transform scale-110 text-gray-50;
}
.card-zoom:hover .card-zoom-image {
  @apply scale-110;
}
.card-zoom:hover .card-zoom-text {
  @apply scale-100;
}

.profile-img {
  padding-bottom: 100%; /* 16:9 */
}

.profile-img img {
  transition: transform 0.3s ease-in-out;
}

.profile-img:hover img {
  transform: scale(1.05);
}

.profile-img:hover::after {
  content: "View Bio";
  position: absolute;
  bottom: 10px;
  right: 10px;
  /* transform: translateX(-50%); */
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  padding: 3px 6px;
  border-radius: 5px;
}
</style>
